'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _expanders = require('../../const/expanders');

var _expanders2 = require('../../utils/expanders');

var _formatting = require('../../utils/formatting');

var _allPartsTransformer = require('../../transformers/composite/allPartsTransformer');

var _allPartsTransformer2 = _interopRequireDefault(_allPartsTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cornerExpander = function cornerExpander() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$mainWrapper = _ref.mainWrapper,
      mainWrapper = _ref$mainWrapper === undefined ? _allPartsTransformer2.default : _ref$mainWrapper,
      _ref$subWrapper = _ref.subWrapper,
      subWrapper = _ref$subWrapper === undefined ? _ramda.identity : _ref$subWrapper,
      _ref$createPropNameSt = _ref.createPropNameStrategy,
      createPropNameStrategy = _ref$createPropNameSt === undefined ? _formatting.appendSubToProp : _ref$createPropNameSt;

  return function (propName, style) {
    return (0, _ramda.converge)(_ramda.pipe, [_expanders2.expandMainProp, (0, _expanders2.expandSubProps)(createPropNameStrategy, _expanders.CORNERS_LIST, subWrapper)])(propName, style, mainWrapper)({});
  };
};

exports.default = cornerExpander;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/expanders/cornerExpander.js
// module id = 647
// module chunks = 168707334958949